module.exports = __webpack_public_path__ + "assets/img/banner10.27d9e59c.jpg";